<template>
  <div>
    <el-dialog
      title="新增用户"
      :visible.sync="createVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <!-- <el-form-item label="ID" :label-width="formLabelWidth" prop="id">
          <el-input v-model="form.id" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="邮箱" :label-width="formLabelWidth" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请输入邮箱地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="pwd" required>
          <el-input
            v-model="form.pwd"
            type="password"
            show-password
            maxlength="22"
            placeholder="请输入密码"
          ></el-input>
          <div class="pwd-tip">
            密码长度需为8-22位，须同时包含数字、大写字母、小写字母和特殊字符，且不能包含空格
          </div>
        </el-form-item>
        <el-form-item label="租户选择" :label-width="formLabelWidth" prop="tenantId">
          <el-select v-model="form.tenantId" placeholder="租户选择" clearable>
            <el-option
              v-for="item in tenantList"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="用户类型"
          :label-width="formLabelWidth"
          prop="userType"
        >
          <el-select
            v-model="form.userType"
            placeholder="请选择用户类型"
            clearable
          >
            <el-option
              v-for="item in Shareholder"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialod('form')">取 消</el-button>
        <el-button type="primary" @click="add('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { simulationUserPasswordRule } from "../../validate";

export default {
  props: ["tenantList"],
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: "80px",
      form: {
        // id: "",
        email: "",
        pwd: "",
        tenantId: "",
        userType: 1,
      },
      Shareholder: [
        { value: 1, label: "模拟盘用户" },
        { value: 2, label: "普通用户" },
      ],
      rules: {
        id: [{ required: true, message: "请输入ID", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }],
        pwd: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          simulationUserPasswordRule,
        ],
        tenantId: [{ required: true, message: "请选择租户", trigger: "change" }],
        userType: [{ required: true, message: "请选择用户类型", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapState("userOldSimulation", ["createVisible"]),
  },
  methods: {
    ...mapMutations("userOldSimulation", ["setCreateVisible"]),
    ...mapActions("userOldSimulation", ["addUser"]),
    add(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUser({ ...this.form }).then((res) => {
            if (res.code == 0) {
              this.$message.success("添加成功");
              this.resetForm(formName);
              this.setCreateVisible(false);
            } else {
              this.$message.error(res.msg || "添加失败");
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeDialod(formName) {
      this.resetForm(formName);
      this.setCreateVisible(false);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.setCreateVisible(false);
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.pwd-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}
</style>
